<div #wrapper class="horizontal-menu">
    <nav class="navbar top-navbar bigger-menu col-lg-12 col-12 p-0">
        <div class="container">
            <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">

                <!--                <ng-container *ngIf="haveMasterProfile && !isUserUnderMasterProfile">-->
                <!--                    <a class="navbar-brand brand-logo" routerLink="/master/dashboard">-->
                <!--                        <img src="assets/images/logo-white.svg" style="width: 85px;" alt="logo"/></a>-->
                <!--                    <a class="navbar-brand brand-logo-mini" routerLink="/master/dashboard">-->
                <!--                        <img src="assets/images/logo-white.svg" style="width: 85px;" alt="logo"/></a>-->
                <!--                </ng-container>-->

                <ng-container *ngIf="haveMasterProfile || isUserUnderMasterProfile">
                    <a class="navbar-brand brand-logo" routerLink="/master/dashboard">
                        <img src="assets/images/agaia-pro-new.png" style="width: 85px;" alt="logo"/></a>
                    <a class="navbar-brand brand-logo-mini" routerLink="/master/dashboard">
                        <img src="assets/images/agaia-pro-new.png" style="width: 85px;" alt="logo"/></a>
                </ng-container>

                <ng-container *ngIf="!haveMasterProfile && !isUserUnderMasterProfile">
                    <a class="navbar-brand brand-logo" routerLink="/dashboard">
                        <img src="assets/images/logo-white.svg" style="width: 85px;" alt="logo"/></a>
                    <a class="navbar-brand brand-logo-mini" routerLink="/dashboard">
                        <img src="assets/images/logo-white.svg" style="width: 85px;" alt="logo"/></a>
                </ng-container>

                <!--                <ng-container *ngIf="!haveMasterProfile && isUserUnderMasterProfile">-->
                <!--                    <a class="navbar-brand brand-logo" routerLink="/dashboard">-->
                <!--                        <img src="assets/images/agaia-pro-new.png" style="width: 85px;" alt="logo"/></a>-->
                <!--                    <a class="navbar-brand brand-logo-mini" routerLink="/dashboard">-->
                <!--                        <img src="assets/images/agaia-pro-new.png" style="width: 85px;" alt="logo"/></a>-->
                <!--                </ng-container>-->

                <div class="navbar-pricing-plan">
                    Базов план
                </div>
            </div>
            <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
                <ul class="navbar-nav navbar-nav-right" *ngIf="!completeHeader">
                    <li class="nav-item">
                        <div class="chat-spinner" (click)="onWebChat()">
                            <div class="big-spinner"></div>
                            <div class="big-spinner-outer"></div>
                        </div>

                        <!--                        <a class="nav-link" (click)="onWebChat()">-->
                        <!--                            <i class="fa fa-wechat mx-0"></i>-->
                        <!--                        </a>-->
                    </li>
                    <li class="nav-item dropdown" ngbDropdown>
                        <a class="nav-link dropdown-toggle" [app-popup]="{
              templateRef: languagesPopupTemplate,
              position: 'bottom',
              arrowPosition: ['top', 'right'],
              paddingless: true,
              closeUponSelection: true
            }">
                            <i class="ti-world mx-0"></i>
                        </a>
                        <ng-template #languagesPopupTemplate>
                            <a class="dropdown-item preview-item" *ngFor="let language of languages"
                               (click)="onLanguageSelected(language)">
                                <div class="preview-thumbnail">
                                    <div class="responsive-flex-wrapper">
                                        <i [ngClass]="'m-0 flag-icon flag-icon-' + flagIcon(language)"></i>
                                    </div>
                                </div>
                                <div class="preview-item-content">{{ language | localise }}</div>
                            </a>
                        </ng-template>
                    </li>
                    <li class="nav-item">
                        <div class="responsive-flex-wrapper" style="cursor: pointer;" (click)="onLogout()">
                            <button class="btn btn-danger">{{ 'logout' | localise }}</button>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav navbar-nav-right" *ngIf="completeHeader">
                    <li class="nav-item">
                        <!--                        <div class="chat-spinner" (click)="onWebChat()">-->
                        <!--                            <div class="big-spinner"></div>-->
                        <!--                            <div class="big-spinner-outer"></div>-->
                        <!--                        </div>-->

                        <!--                        <a class="nav-link" (click)="onWebChat()">-->
                        <!--                            <i class="fa fa-wechat mx-0"></i>-->
                        <!--                        </a>-->
                    </li>
                    <li class="nav-item dropdown" ngbDropdown>
                        <a class="nav-link dropdown-toggle" [app-popup]="{
              templateRef: languagesPopupTemplate,
              position: 'bottom',
              arrowPosition: ['top', 'right'],
              paddingless: true,
              closeUponSelection: true
            }">
                            <i class="ti-world mx-0"></i>
                        </a>
                        <ng-template #languagesPopupTemplate>
                            <a class="dropdown-item preview-item" *ngFor="let language of languages"
                               (click)="onLanguageSelected(language)">
                                <div class="preview-thumbnail">
                                    <div class="responsive-flex-wrapper">
                                        <i [ngClass]="'m-0 flag-icon flag-icon-' + flagIcon(language)"></i>
                                    </div>
                                </div>
                                <div class="preview-item-content">{{ language | localise }}</div>
                            </a>
                        </ng-template>
                    </li>
                    <li class="nav-item nav-profile">
                        <a class="nav-link" [app-popup]="{
              templateRef: profilePopupTemplate,
              position: 'bottom',
              arrowPosition: ['top', 'right'],
              paddingless: true,
              closeUponSelection: true
            }">
                            <img [src]="profileImageSrc" alt="profile"/>
                        </a>
                        <ng-template #profilePopupTemplate>
                            <ng-container *ngIf="!haveMasterProfile">
                                <a *ngIf="authService.userHasLoggedIn && completeHeader && !isUserOnCatering"
                                   class="dropdown-item preview-item"
                                   routerLink="/invoices">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="ti-files text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">{{ 'invoices' | localise }}</div>
                                </a>
                                <a
                                        *ngIf="isDiaryChangeDisabled === false && !isUserOnCatering"
                                        class="dropdown-item preview-item"
                                        routerLink="/user-preferred-global-categories">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="ti-heart text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">{{ 'user_preferred_meals' | localise }}</div>
                                </a>
                                <a
                                        *ngIf="isDiaryChangeDisabled === false && !isUserOnCatering"
                                        class="dropdown-item preview-item" routerLink="/user-preferred-products">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="ti-heart-broken text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">{{ 'exclude_products' | localise }}</div>
                                </a>
<!--                                <a class="dropdown-item preview-item" routerLink="/referrals">-->
<!--                                    <div class="preview-thumbnail">-->
<!--                                        <div class="responsive-flex-wrapper">-->
<!--                                            <i class="icon-people text-primary"></i>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div class="preview-item-content">{{ 'referrals_navbar' | localise }}</div>-->
<!--                                </a>-->
                                <a class="dropdown-item preview-item" routerLink="/videos">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="fa fa-video-camera text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">{{ 'videos' | localise }}</div>
                                </a>
                                <a class="dropdown-item preview-item"
                                   *ngIf="!isUserOnCatering"
                                   routerLink="/settings/profile">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="ti-settings text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">{{ 'settings' | localise }}</div>
                                </a>
                            </ng-container>


                            <ng-container *ngIf="haveMasterProfile">
                                <a class="dropdown-item preview-item" routerLink="/master/profiles">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="ti-user text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">Профили</div>
                                </a>

                                <a appMasterLock class="dropdown-item preview-item" routerLink="/master/statistics">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="ti-stats-up text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">Статистика</div>
                                </a>

                                <a appMasterLock class="dropdown-item preview-item" routerLink="/master/auto/recipes">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="ti-pencil-alt text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">Автоматични рецепти</div>
                                </a>

                                <a appMasterLock class="dropdown-item preview-item" routerLink="/master/settings">
                                    <div class="preview-thumbnail">
                                        <div class="responsive-flex-wrapper">
                                            <i class="ti-settings text-primary"></i>
                                        </div>
                                    </div>
                                    <div class="preview-item-content">{{ 'settings' | localise }}</div>
                                </a>
                            </ng-container>


                            <a class="dropdown-item preview-item" (click)="onLogout()">
                                <div class="preview-thumbnail">
                                    <div class="responsive-flex-wrapper">
                                        <i class="ti-power-off text-primary"></i>
                                    </div>
                                </div>
                                <div class="preview-item-content">{{ 'logout' | localise }}</div>
                            </a>
                        </ng-template>
                    </li>
                </ul>
                <button
                        *ngIf="completeHeader"
                        class="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
                        type="button"
                        (click)="toggleRightSidebar()"
                >
                    <span class="ti-menu"></span>
                </button>
            </div>
        </div>
    </nav>
    <nav #bottomNavbar class="bottom-navbar" *ngIf="completeHeader">
        <div class="container pl-4 pr-4">
            <ul class="nav page-navigation">
                <ng-container *ngIf="!haveMasterProfile">
                    <!--                <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/dashboard"-->
                    <!--                    routerLinkActive="active">-->
                    <!--                    <a classa="nav-link">-->
                    <!--                        <i class="ti-home menu-icon"></i>-->
                    <!--                        <span class="menu-title">{{ 'dashboard' | localise }}</span>-->
                    <!--                    </a>-->
                    <!--                </li>-->
                    <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/meals"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-home menu-icon"></i>
                            <span class="menu-title">{{ 'meals' | localise }}</span>
                        </a>
                    </li>
                    <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="settings/profile/training"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-basketball menu-icon"></i>
                            <span class="menu-title">{{ 'training_info' | localise }}</span>
                        </a>
                    </li>
                    <li *ngIf="authService.userHasLoggedIn && userHasSport" class="nav-item" routerLink="sport"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-basketball menu-icon"></i>
                            <span class="menu-title">Спортна програма</span>
                        </a>
                    </li>
                    <!--                <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/stars"-->
                    <!--                    routerLinkActive="active">-->
                    <!--                    <a class="nav-link">-->
                    <!--                        <i class="ti-star menu-icon"></i>-->
                    <!--                        <span class="star-new">{{ 'dashboard_navbar_new' | localise }}</span>-->
                    <!--                        <span class="menu-title">{{ 'dashboard_stars' | localise }}</span>-->
                    <!--                    </a>-->
                    <!--                </li>-->

<!--                    <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/survey"-->
<!--                        routerLinkActive="active">-->
<!--                        <a class="nav-link">-->
<!--                            <i class="ti-pencil-alt menu-icon"></i>-->
<!--                            <span class="menu-title">Анкети</span>-->
<!--                        </a>-->
<!--                    </li>-->
                    <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/news"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-announcement menu-icon"></i>
                            <span class="menu-title">{{ 'news' | localise }}</span>
                        </a>
                    </li>
                    <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/faq"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-help-alt menu-icon"></i>
                            <span class="menu-title">{{ 'chzv' | localise }}</span>
                        </a>
                    </li>
                </ng-container>

                <ng-container *ngIf="haveMasterProfile">
                    <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/master/dashboard"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-home menu-icon"></i>
                            <span class="menu-title">{{ 'dashboard' | localise }}</span>
                        </a>
                    </li>

                    <li *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/master/profiles"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-user menu-icon"></i>
                            <span class="menu-title">Профили</span>
                        </a>
                    </li>

                    <li appMasterLock *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/master/statistics"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-stats-up menu-icon"></i>
                            <span class="menu-title">Статистика</span>
                        </a>
                    </li>

                    <li appMasterLock *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/master/auto/recipes"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-pencil-alt menu-icon"></i>
                            <span class="menu-title">Автоматични рецепти</span>
                        </a>
                    </li>

                    <li appMasterLock *ngIf="authService.userHasLoggedIn" class="nav-item" routerLink="/master/settings"
                        routerLinkActive="active">
                        <a class="nav-link">
                            <i class="ti-settings menu-icon"></i>
                            <span class="menu-title">Настройки</span>
                        </a>
                    </li>
                </ng-container>
            </ul>
        </div>
    </nav>
</div>
